import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { ButtonInfoSmall } from "../../../generic/common/ButtonInfoSmall";
import { UpgradeTransitionArrow } from "../../../generic/common/UpgradeTransitionArrow";
import { Icon } from "../../../generic/icon/Icon";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { RemainingTimeDisplay } from "../../../generic/remaining-time-display/RemainingTimeDisplay";
import { BuildingItemContainer } from "./BuildingItemContainer";
export var BuildingUpgradeOld = function (_a) {
    var currentStage = _a.currentStage, nextStage = _a.nextStage, building = _a.building, constructionTime = _a.constructionTime, onInfoButton = _a.onInfoButton;
    var buildingName = building.balancing.name;
    var infoButton = onInfoButton ? (React.createElement(ButtonInfoSmall, { onClick: onInfoButton },
        React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))) : (undefined);
    return (React.createElement(React.Fragment, null,
        React.createElement(BuildingItemContainer, { className: "building-old__container", buildingName: buildingName, stage: currentStage }),
        React.createElement("div", { className: "building-upgrade__arrow-wrapper" },
            infoButton,
            React.createElement("div", { className: "building-upgrade__arrow" },
                React.createElement(UpgradeTransitionArrow, null,
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconMedium }),
                        React.createElement("div", { className: IdStyles.TextBoldAccent },
                            React.createElement(RemainingTimeDisplay, { seconds: constructionTime, className: IdStyles.TextBoldPrimary }))))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgradeOld.tsx
// module id = 926
// module chunks = 3